// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { navigationDrawerStyles } from "@stoneage/Overrides/Components/NavigationDrawer";
import { fontConfig } from "@stoneage/XDL/constants";
import { color, xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";
import { IconWrapper } from "@insite/mobius/Icon";
import { buttonTransparent } from "@stoneage/XDL/PreStyle/button";
import IconHeaderMenuClose from "@stoneage/XDL/Icons/IconHeaderMenuClose";
import { PanelRowPresentationProps } from "@insite/mobius/PanelMenu";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { ellipsis } from "@stoneage/XDL/Utilities";

navigationDrawerStyles.drawer = {
    size: 360,
    cssOverrides: {
        drawerTitle: css`
            background-color: ${color("common.ui4")};
            padding: 12px;
            justify-content: flex-end;
            flex-direction: row-reverse;
            gap: 12px;
        `,
        drawerBody: css`
            top: 0;
            transform: translate(-100%, 0);
            height: 100svh;
            box-shadow: none;
            padding: 0 0 8px 0;
            background-color: ${color("common.ui1")};
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
        scrim: css`
            background-color: ${color("common.black", 0.5)};
            top: 0;
            height: 100svh;
        `,
        drawerContent: css`
            padding: 0;
        `,
        titleButton: css`
            ${buttonTransparent}
        `,
        headlineTypography: css`
            padding: 0;
            margin-bottom: 0;
        `,
    },
    headlineTypographyProps: {
        ...fontConfig.h4,
        weight: fontConfig.weight.bold,
        color: fontConfig.headingColor,
        variant: "h4",
    },
    closeButtonProps: {
        color: "transparent",
        css: css`
            padding: 0;
            & > ${IconWrapper} {
                color: ${color("secondary")};
            }

            &,
            &:hover,
            &:focus,
            &:active {
                background: transparent;
                border-color: transparent;
            }

            &:hover > ${IconWrapper} {
                color: ${color("primary")};
            }
        `,
    },
    closeButtonIconProps: {
        src: IconHeaderMenuClose,
        size: 18,
    },
};

navigationDrawerStyles.drawerSectionWrapper = {};

const sharedPanelRowStyle: PanelRowPresentationProps & { typographyProps: TypographyPresentationProps } = {
    color: "transparent",
    typographyProps: {
        ...fontConfig.regularSingleLine,
        weight: fontConfig.weight.bold,
        color: fontConfig.headingColor,
        transform: "capitalize",
        css: css`
            margin: 0;
            ${ellipsis(1)}
        `,
    },
    css: css`
        background-color: transparent;
        text-align: left;
        flex: 1;
    `,
};

navigationDrawerStyles.mainNavigationRow = {
    ...sharedPanelRowStyle,
};

navigationDrawerStyles.mainNavigationRowTypography = {
    ...sharedPanelRowStyle.typographyProps,
};

navigationDrawerStyles.logoLinks = {
    ...sharedPanelRowStyle,
};

navigationDrawerStyles.signOutRow = {
    ...sharedPanelRowStyle,
};

navigationDrawerStyles.signOutRowText = {
    ...sharedPanelRowStyle.typographyProps,
};

navigationDrawerStyles.punchOutUserRowText = {
    ...sharedPanelRowStyle.typographyProps,
};

navigationDrawerStyles.panelMenu = {};

navigationDrawerStyles.panelSectionWrapper = {};

navigationDrawerStyles.divider = {
    css: css`
        position: static;
        background: ${color("common.border")};
        width: calc(100% - 32px);
        height: 1px;
        margin: 12px auto;
    `,
};
